import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '../theme';

export function SvgCheck(props) {
  const { width, height, stroke } = props;
  const theme = useTheme();

  return (
    <svg width={width || '12px'} height={height || '10px'} viewBox="0 0 12 10" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-690.000000, -2616.000000)"
          stroke={stroke || theme.colors.primary20b}
          strokeWidth="2"
        >
          <g transform="translate(687.000000, 2612.000000)">
            <g transform="translate(1.000000, 1.000000)">
              <g transform="translate(-4.000000, -4.000000)">
                <polyline points="17.3333333 8 10 15.3333333 6.66666667 12" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgCheck.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
